import { AxiosResponse } from "axios";
import { http } from "@/utils/http";

export const providerService = {
  getProviders(): Promise<AxiosResponse> {
    return http.get("/eld/providers");
  },
};
